import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
export function FinalCTA() {
  // Generate random rising particles
  const particles = Array.from({
    length: 15
  }).map((_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    delay: `${Math.random() * 5}s`,
    duration: `${3 + Math.random() * 4}s`,
    size: Math.random() > 0.5 ? 'w-1 h-1' : 'w-1.5 h-1.5'
  }));
  return <section className="py-32 border-t border-border relative overflow-hidden" data-id="element-318">
      {/* Dramatic Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/10 rounded-full blur-[120px] pointer-events-none mix-blend-screen aurora-blob" data-id="element-319"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-purple-500/10 rounded-full blur-[100px] pointer-events-none mix-blend-screen aurora-blob" style={{
      animationDelay: '-5s'
    }} data-id="element-320"></div>

      {/* Rising Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-321">
        {particles.map(p => <div key={p.id} className={`absolute bottom-[-10px] ${p.size} bg-primary/50 rounded-full`} style={{
        left: p.left,
        animation: `float-particle ${p.duration} infinite linear`,
        animationDelay: p.delay
      }} data-id="element-322" />)}
      </div>

      <div className="max-w-3xl mx-auto px-6 text-center relative z-10" data-id="element-323">
        <motion.h2 initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        type: 'spring',
        bounce: 0.4
      }} className="text-4xl md:text-6xl font-bold mb-6 leading-tight gradient-text" data-id="element-324">
          Run your booking workflow from one place.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="text-lg md:text-xl text-textMuted mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-325">
          Whether you're trying to build a summer run, fill an empty Saturday,
          or manage a full roster, Booker gives you one operating system for
          live booking.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-326">
          <button className="group w-full sm:w-auto px-8 py-4 text-base font-medium text-background bg-primary rounded-lg hover:bg-primaryHover transition-all hover:-translate-y-1 flex items-center justify-center gap-2" style={{
          animation: 'pulse-glow 3s infinite'
        }} data-id="element-327">
            Start free today
            <ChevronRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-328" />
          </button>
          <button className="w-full sm:w-auto px-8 py-4 text-base font-medium text-textMain border border-border rounded-lg hover:bg-surface transition-colors flex items-center justify-center hover:-translate-y-1" data-id="element-329">
            Book a demo
          </button>
        </motion.div>
      </div>
    </section>;
}